export default {
  // Index
  // upcomingChats listed in dashboard
  chatHistory: {
    english: "Chat History",
    spanish: "Historial de citas"
  },
  noUpcomingChats: {
    english: "You have no upcoming chats",
    spanish: "No tienes citas próximas"
  },
  myAppointments: {
    english: "My Appointments",
    spanish: "Mis Citas"
  },
  youHaveUpcomingAppointments: {
    english: "You have {0} upcoming appointments",
    spanish: "Tienes {0} citas próximas"
  },
  join: {
    english: "Join",
    spanish: "Entrar"
  },

  // Join-Chat-Btn
  startsIn: {
    english: "Starts in",
    spanish: "Empieza en"
  },
  days: {
    english: "days",
    spanish: "dias"
  },
  hours: {
    english: "Hrs",
    spanish: "Horas"
  },
  minutes: {
    english: "minutes",
    spanish: "minutos"
  },
  // Reschedule-Chat-Btn
  rescheduleChat: {
    english: "Reschedule Chat",
    spanish: "Reprogramar cita"
  },
  reschedule: {
    english: "Reschedule",
    spanish: "Reprogramar"
  },
  // Upcoming-Chat
  date: {
    english: "Date",
    spanish: "Fecha"
  },
  topic: {
    english: "Topic",
    spanish: "Tema"
  },
  description: {
    english: "Description",
    spanish: "Descripción"
  },
  with: {
    english: "With",
    spanish: "Con"
  },
  confirmationPending: {
    english: "Pending",
    spanish: "Pendiente"
  },
  completed: {
    english: "Completed",
    spanish: "Completado"
  },
  confirmed: {
    english: "Confirmed",
    spanish: "Confirmado"
  },
  declined: {
    english: "Declined",
    spanish: "Rechazado"
  },
  rescheduled: {
    english: "Rescheduled",
    spanish: "Reprogramado"
  },
  canceled: {
    english: "Canceled",
    spanish: "Cancelado"
  },
  
  // Comes from S3_TimeSlots MasterChatType
  // Text Chat listed in video-chat-history
  "Video Chat": {
    english: "Video Chat",
    spanish: "Chat de video"
  },
  "Product Demo": {
    english: "Product Demo",
    spanish: "Demostración del producto"
  },
  cancelAppointment: {
    english: "Cancel Appointment",
    spanish: "Cancelar cita"
  },
  cancelAppointmentConfirmationMessage: {
    english: "Are you sure you want to cancel the appointment?",
    spanish: "¿Está seguro que desea cancelar su cita?"
  },
  yes: { english: "Yes", spanish: "Sí" },
  statusCancelled: { english: "Canceled", spanish: "Cancelada" },
  startsNow: { english: "Starts now", spanish: "Comienza ahora" },

  declineAppointmentConfirmation: {
    english: "Are you sure you want to reject this appointment?",
    spanish: "¿Está seguro de que desea rechazar la cita?"
  },
  declineAppointmentSummary: {
    english: "Decline Appointment",
    spanish: "Rechazar Cita"
  },
  declineAppointmentActionText: {
    english: "Decline",
    spanish: "Rechazar"
  },
  accept: {
    english: "Accept",
    spanish: "Aceptar"
  },
  actions: {
    english: "Actions",
    spanish: "Acciones"
  }
};
